var m = require('mithril');
var prop = require('mithril/stream')
var modal = require('../../layout/components/modal');
var key = require('../../libs/keybindings');
var loaders = require('../../layout/components/loaders');

var enumerationClearModal = {};

modal.once('closed', function() {
  key.deleteScope('modal');
  key.setScope('home');
});


enumerationClearModal.editDialogue = function(pointRecord, options) {
  enumerationClearModal.enumerations = prop([]);
  enumerationClearModal.pointRecord = pointRecord;
  enumerationClearModal.options = options;


  var submit = function() {
    let body = {
      enumeration: ''
    }

    return loaders.requestWithLoader({
      method: 'PUT',
      url: `/api/v1/point/${enumerationClearModal.pointRecord()['@rid'].slice(1)}`,
      body
    }).then(response=>{
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.close();
    })
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title("Confirm clear enumeration config");
  modal.vm.body = view;
  modal.vm.buttons([
    {
      label: "Cancel",
      class: "f4 ba bw1 ph3 pv2 tc v-btm dib mr2",
      func: modal.vm.close.bind(modal)
    },
    {
      label: "Confirm",
      class: "dib red",
      func: submit
    },

  ])

  modal.vm.open()
};



function view() {
  return m('form', {role:'form'}, [
    m('p', 'Are you sure you want to clear enumeration config for this point?')
  ])
}

module.exports = enumerationClearModal;
